import {defineMessages} from 'react-intl'

/**
 * Copy for the My List framing, shown to brands with `hasMyListFraming`.
 *
 * Ids match the mobile app's verbatim so the translations transfer instead of
 * needing a fresh round. Translated fresh: `listToggle`, which the translation
 * team renamed from the app's `watchListToggle`, and the web-only `listSave`
 * and `listShare`. `listSave` stays separate from `preferencesSaveButton`
 * because this Save means bookmarking, which translates differently.
 */
export const myListMessages = defineMessages({
  tabLabel: {
    id: 'listTabLabel',
    defaultMessage: 'My list'
  },
  save: {
    id: 'listSave',
    defaultMessage: 'Save'
  },
  share: {
    id: 'listShare',
    defaultMessage: 'Share'
  },
  toggle: {
    id: 'listToggle',
    defaultMessage: 'Save this stay to your list'
  },
  anchorCardTitle: {
    id: 'listAnchorCardTitle',
    defaultMessage: 'Save to list'
  },
  anchorCardDescription: {
    id: 'listAnchorCardDescription',
    defaultMessage: 'Get alerts when the price changes'
  },
  onboardingTitle: {
    id: 'listOnboardingTitle',
    defaultMessage: 'All your saved stays in one place'
  },
  saveStayDescription: {
    id: 'listSaveStayDescription',
    defaultMessage:
      "Save a stay for later with the {icon} icon. We'll track the price, then tell you if it changes."
  },
  susiSaveTitle: {
    id: 'listSusiSaveTitle',
    defaultMessage: 'Save this stay for later'
  },
  susiSaveDescription: {
    id: 'listSusiSaveDescription',
    defaultMessage:
      "Add a stay to your list and we'll track the price, then let you know if it changes."
  },
  apCardDescription: {
    id: 'listApCardDescription',
    defaultMessage:
      "Add this stay to your list and we'll track the price, then let you know if it changes."
  },
  toastAdded: {
    id: 'listToastAdded',
    defaultMessage:
      '{hotel} {checkIn} - {checkOut} added to your list. Started tracking price.'
  },
  toastRemoved: {
    id: 'listToastRemoved',
    defaultMessage: '{hotel} {checkIn} - {checkOut} removed from your list.'
  },
  alertStopped: {
    id: 'listAlertStopped',
    defaultMessage: '{hotelName} removed from your list'
  },
  emptyTitle: {
    id: 'listEmptyTitle',
    defaultMessage: 'Your list is empty'
  },
  emptyDescriptionLoggedOut: {
    id: 'listEmptyDescriptionLoggedOut',
    defaultMessage:
      'Sign in to see your saved stays, add stays to your list, and track prices while you browse.'
  },
  onboardingBannerDescription: {
    id: 'listOnboardingBannerDescription',
    defaultMessage:
      "We'll let you know when prices change, so you've always got the latest info."
  }
})
